angular.module('rentalListingModule').component('rentalListingSuccessMessage', {
	templateUrl: 'rentalListingSuccessMessage/rentalListingSuccessMessage.html',
	bindings: {
		to: '<',
		listing: '<',
		steps: '<',
		imageSrc: '<',
		isMobile: '<',
		listingUrl: '<',
		allowToAddNewListing: '<',
		forAddListing: '<',
		user: '<',
		userType: '<',
		onClickNext: '&',
		onClearForm: '&'
	},
	controller: ['$http', function($http) {
		this.forAddListing = this.forAddListing || this.listing.addFromBuildingManager;

		this.clickNext = function() {
			// reset the listing object when the user wants to add another listing
			this.onClearForm({form: null});

			var to = this.allowToAddNewListing ? this.steps.addListing : this.steps.limitMessage;
			this.onClickNext({to: to});
		};
	}]
});
